// extracted by mini-css-extract-plugin
export default {"input":"styles_input__2VV4h","input__input":"styles_input__input__4mTSf"};